import { DropdownMenu, XGridTableWrap } from '@tap/mui-ui';
import {
    GridCellEditCommitParams,
} from '@mui/x-data-grid-pro';
import { Grid, IconButton, Button, Tooltip, Stack } from '@mui/material';
import { useState, useEffect } from 'react';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import PrintOutlineOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { AttachmentsBlockProps } from '@tap/tap-ui';
import { IApiIssue, issueService } from '@tap/data-providers';
import { printReportFiles, ReportNames } from '@tap/mui-ui/src/utils/printReportFiles';
import { useSnackbar } from 'notistack';
import { useDocuemtnSchema } from '../../context';
import { getDocumentGridColumnList } from '../../components';

const attachmentGridFileResult = 'attachmentGridFileResult';

/*
*   Таблица операции
*/

export type UseAttachmentGridProps = {
    documentKey: string,
    attachmentsBlockProps: AttachmentsBlockProps,
}

export const useAttachmentGrid = ({
    documentKey,
    attachmentsBlockProps,
}: UseAttachmentGridProps) => {
    // const uploadInputRef = useRef<HTMLInputElement | undefined>(undefined);
    // const hundleOpenSelectFile = () => {
    //     uploadInputRef?.current?.children?.[0] && (uploadInputRef.current.children[0] as HTMLInputElement).click();
    // }

    return {
        documentKey, attachmentsBlockProps,
        //attachmentsState, hundleOpenSelectFile, uploadInputRef
    };
}

export const NoRowsOverlay = ({ attachmentsBlockProps, widgetSettings }: any) => {
    return (
        <Stack
            height="100%"
            alignItems="center"
            justifyContent="center"
            sx={{ fontWeight: 400, zIndex: 100, pointerEvents: 'all', width: '100%' }}
        >
            <Button
                size='small'
                onClick={() => { console.log('TODO') }}
                startIcon={<DownloadOutlinedIcon />}
            >
                {widgetSettings.downloadTemplateBtn}

            </Button>

            <Button
                size='small'
                onClick={() => {
                    attachmentsBlockProps.hundleOpenSelectFile(attachmentGridFileResult);
                }}
                startIcon={<BackupOutlinedIcon />}
            >
                {widgetSettings.uploadFileBtn}
            </Button>

        </Stack>
    );
}

export type AttachmentGridProps = {
    documentKey: string,
    attachmentsBlockProps: AttachmentsBlockProps,
    document: IApiIssue,
}

export const AttachmentGrid = ({
    documentKey,
    attachmentsBlockProps,
    document,
}: AttachmentGridProps) => {

    const [documentCode] = documentKey.split('-');
    const documentSchema = useDocuemtnSchema(documentCode);

    const [dropdownMenuAnchorEl, setDropdownMenuAnchorEl] = useState<null | HTMLElement>(null);

    const [isChanged, setIsChanged] = useState<boolean>(true);
    const attachmentGridFileExists = Boolean(document.data[attachmentGridFileResult]);
    const [itemList, setItemList] = useState<any[]>([]);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const data = attachmentGridFileExists
            ? (documentSchema.settings.testData || []).filter(i => !i.issueType || i.issueType === document.data.type)
            : [];
        setItemList(data);
    }, [attachmentGridFileExists])

    const handleCellEditCommit = (params: GridCellEditCommitParams): void => {
        setIsChanged(true);
        setItemList((prev) =>
            prev.map(row => (row.id !== params.id ? row : { ...row, [params.field]: params.value })),
        )
    }

    const handlePrint = (): void => {
        if (!attachmentGridFileExists)
            return;

        let report = ReportNames.WIPChange;
        let data = {};

        switch (document.data.type) {
            case 'change-wip':
                report = ReportNames.WIPChange;
                data = {
                    wipNumber: document.id,
                    manufactory: document.data.department.manufacture,
                    sector: document.data.department.sector,
                    wips: itemList
                        .map((wip: any) => {
                            const amount = wip.amount.split(' ');
                            const operation = wip.operation.split(' ');
                            return {
                                routeCode: wip.routeCode,
                                amount: amount[0],
                                mu: amount[1],
                                operation: operation[0],
                                operationName: operation[1],
                                order: wip.mesOrderNumber,
                                detailVendorCode: wip.productUnitCode,
                                material: wip.productUnitName,
                                routePoint: wip.routePointNumber,
                            }
                        }),
                };
                break;

            case 'product-release':
                report = ReportNames.ConsumptionEndProducts;
                data = {
                    wipNumber: document.id,
                    manufactory: document.data.department.manufacture,
                    sector: document.data.department.sector,
                    wips: itemList
                        .map((wip: any) => {
                            const amount = wip.amount.split(' ');
                            return {
                                amount: amount[0],
                                mu: amount[1],
                                order: wip.mesOrderNumber,
                                detailVendorCode: wip.productUnitCode,
                                material: wip.productUnitName,
                            }
                        }),
                };
                break;

            case 'delivery':
                report = ReportNames.ToolIssuing;
                data = {
                    appNumber: document.id,
                    manufactory: document.data.department.manufacture,
                    sector: document.data.department.sector,
                    workplaceNumber: document.data.inventoryNumber,
                    workplaceModel: document.data.equipmentModel,
                    tools: itemList
                        .map((tool: any) => {
                            return { ...tool, wear: tool.wearPercentage }
                        }),
                };
                break;

            case 'return-tool':
                report = ReportNames.ToolReturns;
                data = {
                    appNumber: document.id,
                    manufactory: document.data.department.manufacture,
                    sector: document.data.department.sector,
                    workplaceNumber: document.data.inventoryNumber,
                    workplaceModel: document.data.equipmentModel,
                    tools: itemList
                        .map((tool: any) => {
                            return { ...tool, wear: tool.wearPercentage }
                        }),
                };
                break;
        }

        printReportFiles({
            requestData: data,
            setIsLoading: (loading: boolean) => (loading),
            reportName: report,
            showError: (errorMessage) => enqueueSnackbar(errorMessage, { variant: 'error' }),
        });
    };

    const handleDownloadTemplate = () => {
        console.log('TODO');
    }

    const handleUploadSourceFile = () => {
        attachmentsBlockProps.hundleOpenSelectFile(attachmentGridFileResult);
    };

    const handleDeleteSourceFile = () => {
        return issueService.updateIssue(documentKey, { data: { [attachmentGridFileResult]: null } })
            .then(() => {
                document.data[attachmentGridFileResult] = undefined;
                setItemList([]);
            });
    };


    const widgetSettings = document.data.type === 'change-wip'
        ? documentSchema.settings.attachmentGridProps2
        : documentSchema.settings.attachmentGridProps;

    return (
        <Grid container sx={{ position: 'relative' }}>
            <Grid
                sx={{
                    position: 'absolute',
                    top: '-35px',
                    right: '0px',
                }}
            >
                {isChanged &&
                    <>
                        <Button
                            size='small'
                            disabled={!attachmentGridFileExists}
                            onClick={() => handlePrint()}
                            startIcon={<PrintOutlineOutlinedIcon />}
                        >
                            {widgetSettings.printBtn}
                        </Button>
                    </>
                }

                <>
                    <Tooltip title='Ещё'>
                        <IconButton
                            size='small'
                            onClick={e => setDropdownMenuAnchorEl(e.currentTarget)}
                        >
                            <MoreHorizIcon />
                        </IconButton>
                    </Tooltip>

                    {/* Выпадающее меню */}
                    <DropdownMenu
                        anchorEl={dropdownMenuAnchorEl}
                        open={!!dropdownMenuAnchorEl}
                        onClose={() => setDropdownMenuAnchorEl(null)}
                        menuItems={[
                            {
                                label: widgetSettings.uploadOtherFile,
                                onClick: handleUploadSourceFile,
                            },
                            {
                                label: widgetSettings.downloadTemplate,
                                onClick: handleDownloadTemplate,
                            },
                            {
                                label: widgetSettings.deleteData,
                                onClick: handleDeleteSourceFile,
                            },
                        ]}
                    />
                </>
            </Grid>

            <Grid
                sx={{
                    height: '360px',
                    width: 1,
                    '& [role=row]:hover': {
                        '._actions': {
                            'div:first-of-type': {
                                display: 'block',
                            },
                        },
                    },
                }}
            >

                <XGridTableWrap
                    rows={itemList}
                    dataIsLoading={false}
                    tableHeight={'360px'}
                    tableProps={{
                        disableColumnFilter: true,
                        slotProps: {
                            cell: {
                                tabIndex: 0,
                            },
                            noRowsOverlay: {
                                documentKey,
                                attachmentsBlockProps,
                                widgetSettings,
                            },
                        },
                        slots: {
                            noRowsOverlay: NoRowsOverlay,
                            toolbar: null,
                        },
                        onCellEditCommit: handleCellEditCommit,
                    }}
                    columns={
                        getDocumentGridColumnList(documentSchema.settings.attachmentGridColumns
                            .filter(c => !c.filterTypes || c.filterTypes.includes(document.data.type)))
                    }
                />
            </Grid>
        </Grid>
    );
}
